function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
          
        if(!this.mainDetailsToggle.classList.contains('mobile-facets__disclosure')) {
            details.removeAttribute('open');
        }
          
        details.classList.remove('menu-opening');
        });
    
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    
   
    if(this.classList.contains('quick-add-modal')) {
       document.body.classList.add('quick-view-open');
    }
    
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    
     if(this.classList.contains('quick-add-modal')) {
       document.body.classList.remove('quick-view-open');
     }
    
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
   
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      
      console.log('update', this.currentPage);



       //=======================Custom
   
      console.log('UPDATE', this.currentPage, this.querySelector('.product__media-list'), this.sliderItemsToShow[this.currentPage-1]);
       if(this.querySelector('.product__media-list')) {
         let videoElement = this.sliderItemsToShow[this.currentPage-1]?.querySelector('video');
         if(videoElement) {

            let videoElements = this.sliderItemsToShow[this.currentPage-1]?.querySelectorAll('video');
            let mediaPoster = this.sliderItemsToShow[this.currentPage-1]?.querySelector('.media-type-video .deferred-media__poster');
           
          setTimeout(function(){ 
              videoElements.forEach((video) => {
                console.log('PLAY', video);
                video.play();
              });
             }, 500);

          setTimeout(function(){ 
             if(mediaPoster) { 
                let event = new CustomEvent("click", { "detail": "Example of an event" });
                mediaPoster.dispatchEvent(event);
               console.log('PLAY INNER');
             }
          }, 300);
           
         }
         else {
           console.log('PAUSE ALL', this.querySelectorAll('video'));
           this.querySelectorAll('video').forEach((video) => video.pause());
         }
       }
    
      
      
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );

      
      
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {


    
    this.slider.scrollTo({
      left: position,
    });



    
    
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.monogramDrawer = document.querySelector("monogram-drawer");
    this.monogramCanvas = this.monogramDrawer.querySelector("[js-monogram-canvas]");
    this.monogramId = this.monogramDrawer.querySelector("[js-monogram-product-id]");
    this.groupMediaGallery = document.querySelector("[js-product-group-media-gallery]");
    this.media = this.groupMediaGallery?.querySelectorAll("[data-media-alt]");

    document.addEventListener("remove-trap-disabled", this.removeTrapDisable.bind(this));
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId(event);
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.removeTrapDisable();
    this.updateGiftNotesId();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.groupMediaGallery ? this.updateGroupMedia(event) : this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      if(document.body.classList.contains("template-product") || document.body.classList.contains("template-collection")) {
        this.updateMonogramImage();
        this.updateMonogramId();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId({ target }) {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if(!this.currentVariant) {
      const selectedOption = target.value;
      this.currentVariant = this.getVariantData().find((variant) => variant.options.includes(selectedOption) && variant.available);
    }
  }

  updateMonogramImage() {
    if (!this.currentVariant) return;
    this.monogramCanvas.style.backgroundImage = `url('${this.currentVariant.featured_image.src}')`;
  }

  updateMonogramId() {
    if (!this.currentVariant) return;
    this.monogramDrawer.setAttribute('data-variant-id', this.currentVariant.id);
    this.monogramId.value = this.currentVariant.id;
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateGroupMedia({ target }) {
    const regex = /Color|Alphabet/i;
    if (!this.currentVariant || !regex.test(target.name)) return;
    const alt = `${target.name.toLowerCase()}_${target.value.replace(/\s/g, "").toLowerCase()}`;
    var SliderComponentssss = this.groupMediaGallery.querySelector("slider-component");
    this.media.forEach( media => {
      if(media.getAttribute("data-media-alt") === alt) {
        media.classList.contains("thumbnail-list__item") ? media.classList.remove("thumbnail-list_item--variant") : media.classList.remove("product__media-item--variant");
      }
      else if(SliderComponentssss.parentElement.getAttribute("data-product-name") === media.getAttribute("data-media-alt")){
        media.classList.contains("thumbnail-list__item") ? media.classList.remove("thumbnail-list_item--variant") : media.classList.remove("product__media-item--variant");
      }
      else {
        media.classList.contains("thumbnail-list__item") ? media.classList.add("thumbnail-list_item--variant") : media.classList.add("product__media-item--variant");
      }
    });

    const firstThumbnailSlide = this.groupMediaGallery.querySelector(".thumbnail-list__item:not(.thumbnail-list_item--variant)");
    const SliderComponent = this.groupMediaGallery.querySelector("slider-component");

    SliderComponent.initPages();
    const resizeObserver = new ResizeObserver((entries) => SliderComponent.initPages());
    resizeObserver.observe(SliderComponent.querySelector('[id^="Slider-"]'));

    firstThumbnailSlide.querySelector("button").click();
  }
  // updateGroupMedia({ target }) {
  //   const regex = /Color|Alphabet/i;
  //   if (!this.currentVariant || !regex.test(target.name)) return;
  //   const alt = `${target.name.toLowerCase()}_${target.value.replace(/\s/g, "").toLowerCase()}`;
    
  //   this.media.forEach( media => {
  //     if(media.getAttribute("data-media-alt") === alt) {
  //       media.classList.contains("thumbnail-list__item") ? media.classList.remove("thumbnail-list_item--variant") : media.classList.remove("product__media-item--variant");
  //     }else {
  //       media.classList.contains("thumbnail-list__item") ? media.classList.add("thumbnail-list_item--variant") : media.classList.add("product__media-item--variant");
  //     }
  //   });

  //   const firstThumbnailSlide = this.groupMediaGallery.querySelector(".thumbnail-list__item:not(.thumbnail-list_item--variant)");
  //   const SliderComponent = this.groupMediaGallery.querySelector("slider-component");

  //   SliderComponent.initPages();
  //   const resizeObserver = new ResizeObserver((entries) => SliderComponent.initPages());
  //   resizeObserver.observe(SliderComponent.querySelector('[id^="Slider-"]'));

  //   firstThumbnailSlide.querySelector("button").click();
  // }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  removeTrapDisable() {
    const trapDisableEl = document.querySelector(".is-alphabet-product");
    if(!trapDisableEl) return;

    const monogramBtn = trapDisableEl.querySelector("[js-monogram-btn]");
    trapDisableEl?.classList.remove("is-alphabet-product");
    monogramBtn?.removeAttribute("disabled");
  }

  updateGiftNotesId() {
    const giftNotesBtn = document.querySelector("[js-gift-note-modal-btn]");
    if(!giftNotesBtn) return;

    const btnLabel = giftNotesBtn.querySelector("span");
    giftNotesBtn.setAttribute("data-variant-id", this.currentVariant.id);
    if(this.currentVariant.available) {
      btnLabel.innerText = "Add your message";
      giftNotesBtn.classList.remove("disabled");
    }else {
      btnLabel.innerText = "Sold out";
      giftNotesBtn.classList.add("disabled");
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    
    let hideVariantsJson = JSON.parse(this.querySelector('[js-variant-hide-json][type="application/json"]').textContent);
    
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      
      // const availableOptionInputsValue = selectedOptionOneVariants
      //   .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
      //   .map((variantOption) => variantOption[`option${index + 1}`]);

      const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => {
        let hideVariant = false;
        hideVariantsJson.forEach((item, i) => {
          if(item.variantId == variant.id && item.hideVariant == 'true') {
            hideVariant = true;
          }
        });
        // let hideVariant = hideVariantsJson.find((item, i) => ((item.variantId == variant.id && item.hideVariant == 'true')? true: false));
        //  console.log('hideVariant', hideVariant);
        return (!hideVariant && variant.available && variant[`option${index}`] === previousOptionSelected);
      }).map((variantOption) => variantOption[`option${index + 1}`]);
      
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[js-variant-data-json][type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          new Swiper('.product_recommendations_slider', {
            loop: false,
            grabCursor: false,
            spaceBetween: 33,
            slidesPerGroup: 4,
            slidesPerView: 4,
            watchSlidesProgress: true,
            draggable:!0,
            autoHeight:!1,
            watchOverflow:!0,
            threshold:10,
            mousewheel:{
              forceToAxis:!0
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              0: {
                slidesPerGroup: 1,
                spaceBetween: 10,
                slidesPerView: "auto",
                centeredSlides: true,
                loop: true,
              },
              750: {
                slidesPerGroup: 2,
                spaceBetween: 16,
                slidesPerView: "auto",
                centeredSlides: true,
                loop: true,
              },
              990: {
                slidesPerGroup: 4,
                spaceBetween: 33,
                slidesPerView: 4,
              },
              1241: {
                slidesPerGroup: 4,
                slidesPerView: 4,
              },
              1440: {
                slidesPerGroup: 4,
                slidesPerView: 4,
                freeMode:!0
              }
            }
         })
          
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function initShippingMessage() {
  const cutOffMessage = document.getElementById('cut-off-time-message');
  function updateCutoffMessage(testDate, test = false) {
    const now = testDate || new Date();
    const cutoffTime = new Date(now);

    if (test) {
        console.log('::: pre cutoffTime:', cutoffTime.toLocaleString('en-GB', { timeZone: 'Europe/London' }));
    }

    cutoffTime.setUTCHours(12, 0, 0, 0); // 12pm UK time. Make 11 to adjust for BST.
    
    if (test) {
        console.log('::: post cutoffTime:', cutoffTime.toLocaleString('en-GB', { timeZone: 'Europe/London' }));
    }

    // Determine the next working day
    let nextWorkingDay = new Date(now);

    // NORMAL DELIVERY TIMES updated 23rd Jan 2024 by Jonny Sadler

    if (now.getDay() === 0 || now.getDay() === 6) {
        nextWorkingDay.setDate(nextWorkingDay.getDate() + ((now.getDay() === 6) ? 3 : 2)); // Next Tuesday if Saturday or Sunday
    } else if (now.getDay() === 5) {
        nextWorkingDay.setDate(nextWorkingDay.getDate() + (now > cutoffTime ? 4 : 1)); // Next Tuesday if Friday after cutoff time, otherwise next day if before cutoff
    // } else if (now.getDay() === 4 && now > cutoffTime) {
    //     nextWorkingDay.setDate(nextWorkingDay.getDate() + 4); // Next Monday if Thursday after cutoff time
    } else if (now > cutoffTime) {
        nextWorkingDay.setDate(nextWorkingDay.getDate() + 2); // Next day if after cutoff time
    } else {
        nextWorkingDay.setDate(nextWorkingDay.getDate() + 1); // Tomorrow if before cutoff time
    }

      // BF23 DELIVERY - additional day

    //  if (now.getDay() === 0 || now.getDay() === 6) {
          // Next Tuesday if Saturday or Sunday, otherwise next Monday
    //      nextWorkingDay.setDate(nextWorkingDay.getDate() + ((now.getDay() === 6) ? 4 : 3));
    //  } else if (now.getDay() === 5) {
          // Next Tuesday if Friday after cutoff time, otherwise next Monday
    //      nextWorkingDay.setDate(nextWorkingDay.getDate() + (now > cutoffTime ? 5 : 4));
    //  } else if (now.getDay() === 4 && now > cutoffTime) {
          // Next TUESDAY if Thursday after cutoff time
    //      nextWorkingDay.setDate(nextWorkingDay.getDate() + 5);
    //  }  else if (now.getDay() === 4 && now < cutoffTime) {
          // Next MONDAY if Thursday BEFORE cutoff time
    //      nextWorkingDay.setDate(nextWorkingDay.getDate() + 4);
    //  } else if (now > cutoffTime) {
    //      nextWorkingDay.setDate(nextWorkingDay.getDate() + 3); // Next day if after cutoff time
    //  } else {
    //      nextWorkingDay.setDate(nextWorkingDay.getDate() + 2); // Tomorrow if before cutoff time
    //  }



    // Calculate the time remaining until the cutoff time
    let hours = Math.floor((cutoffTime - now) / (1000 * 60 * 60));
    let minutes = Math.floor(((cutoffTime - now) % (1000 * 60 * 60)) / (1000 * 60));

    // Construct the message based on the time remaining
    let message = '';

    if (test) {
        console.log('::: now:', now.toLocaleString('en-GB', { timeZone: 'Europe/London' }));
        console.log('::: nextWorkingDay:', nextWorkingDay.toLocaleString('en-GB', { timeZone: 'Europe/London' }));
        console.log('::: hours: ', hours);
        console.log('::: minutes: ', minutes);
    }

    //ORIGINAL JEAN CODE TO RESTORE AFTER BLACK FRIDAY

    //if (hours >= 0 && hours < 12 && now.getDay() !== 0 && now.getDay() !== 6) {
        // message = `Order within <span>${hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''}` : ''}${minutes ? ` ${minutes} min` : ''}</span> to get it by <span>${(now.getDay() === 5 ? 'Monday' : 'Tomorrow')}, ${nextWorkingDay.toLocaleString('en-US', { month: 'short' })} ${nextWorkingDay.getDate()}</span>, `;
    //} else {
        //message = `Get it by <span>${['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][nextWorkingDay.getDay()]}, ${nextWorkingDay.toLocaleString('en-US', { month: 'short' })} ${nextWorkingDay.getDate()}</span>, `;
    //} 


    if (hours >= 0 && hours < 12 && now.getDay() !== 0 && now.getDay() !== 6) {
        message = `Order within <span>${hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''}` : ''}${minutes ? ` ${minutes} min` : ''}</span> to get it by <span>${['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][nextWorkingDay.getDay()]}, ${nextWorkingDay.toLocaleString('en-US', { month: 'short' })} ${nextWorkingDay.getDate()}</span>, `;
    } else {
        message = `Get it by <span>${['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][nextWorkingDay.getDay()]}, ${nextWorkingDay.toLocaleString('en-US', { month: 'short' })} ${nextWorkingDay.getDate()}</span>, `;
    }

    message += 'when you select <span class="intelligems-6604ffe0">Express Delivery</span> at checkout.';

    // Update the DOM element with the new message
    cutOffMessage.innerHTML = message;
  }

  // Update the message initially and then every minute
  if(cutOffMessage) {
    updateCutoffMessage();
    setInterval(updateCutoffMessage, 60 * 1000); // Update every minute   
  }

}
initShippingMessage();
document.addEventListener("shipping-message:init", initShippingMessage)

class giftNotesModal extends HTMLElement {
  constructor() {
    super();

    this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.giftNotes = this.querySelector("[js-gift-notes]");
    this.charCount = this.querySelector("[js-char-count]")
    this.atcBtn = this.querySelector("[js-atc-btn]");

    this.addEventListener('click', (evt) => {
      if(evt.target.classList.contains("gn-modal__background") || evt.target.classList.contains("gn-modal__close")) {
        this.classList.remove("is-open");
        setTimeout(() => {
          this.remove();
        }, 500)
      }
    });

    this.atcBtn.addEventListener('click', this.triggerAddToCart.bind(this));
    this.giftNotes.addEventListener("input", this.updatePreview.bind(this));
  }

  containsEmoji(text) {
    const emojiPattern = /[\u{1F300}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}]/u;
    return emojiPattern.test(text);
  }

  filterEmoji(value) {
    this.giftNotes.value = value.replace(/[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}\u{1F191}-\u{1F251}\u{1F004}\u{1F0CF}\u{1F170}-\u{1F171}\u{1F17E}-\u{1F17F}\u{1F18E}\u{3030}\u{2B50}\u{2B55}\u{2934}-\u{2935}\u{2B05}-\u{2B07}\u{2B1B}-\u{2B1C}\u{3297}\u{3299}\u{23E9}-\u{23F3}\u{231A}-\u{231B}\u{23F0}\u{23F3}\u{2B05}-\u{2B07}\u{3297}\u{3299}\u{203C}\u{2049}\u{25AA}-\u{25AB}\u{25B6}\u{25C0}\u{25FB}-\u{25FE}\u{00A9}\u{00AE}\u{2122}\u{2139}\u{23E9}-\u{23EC}\u{23F0}-\u{23F3}\u{267F}\u{2693}\u{26A1}\u{26AA}-\u{26AB}\u{26BD}-\u{26BE}\u{26C4}-\u{26C5}\u{26CE}\u{26D4}\u{26EA}\u{26F2}-\u{26F3}\u{26F5}\u{26FA}\u{26FD}\u{2705}\u{270A}-\u{270B}\u{2728}\u{274C}\u{274E}\u{2753}-\u{2755}\u{2757}\u{2795}-\u{2797}\u{27B0}\u{27BF}\u{2B1B}-\u{2B1C}\u{2B50}\u{2B55}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F19A}\u{1F1E6}-\u{1F1FF}\u{1F201}-\u{1F251}\u{1F300}-\u{1F321}\u{1F324}-\u{1F393}\u{1F396}-\u{1F397}\u{1F399}-\u{1F39B}\u{1F39E}-\u{1F3F0}\u{1F3F3}-\u{1F3F5}\u{1F3F7}-\u{1F4FD}\u{1F4FF}-\u{1F53D}\u{1F549}-\u{1F54E}\u{1F550}-\u{1F567}\u{1F56F}-\u{1F570}\u{1F573}-\u{1F57A}\u{1F587}\u{1F58A}-\u{1F58D}\u{1F590}\u{1F595}-\u{1F596}\u{1F5A4}-\u{1F5A5}\u{1F5A8}\u{1F5B1}-\u{1F5B2}\u{1F5BC}-\u{1F5BC}\u{1F5C2}-\u{1F5C4}\u{1F5D1}-\u{1F5D3}\u{1F5DC}-\u{1F5DE}\u{1F5E1}\u{1F5E3}\u{1F5E8}\u{1F5EF}\u{1F5F3}\u{1F5FA}-\u{1F64F}\u{1F680}-\u{1F6C5}\u{1F6CB}-\u{1F6D2}\u{1F6E0}-\u{1F6E5}\u{1F6E9}\u{1F6EB}-\u{1F6EC}\u{1F6F0}\u{1F6F3}-\u{1F6FC}\u{1F7E0}-\u{1F7EB}\u{1F90D}-\u{1F93A}\u{1F93C}-\u{1F945}\u{1F947}-\u{1F971}\u{1F973}-\u{1F976}\u{1F97A}-\u{1F97C}\u{1F97E}-\u{1F9A2}\u{1F9B0}-\u{1F9B9}\u{1F9C0}-\u{1F9C2}\u{1F9D0}-\u{1F9FF}\u{1FA70}-\u{1FA73}\u{1FA78}-\u{1FA7A}\u{1FA80}-\u{1FA82}\u{1FA90}-\u{1FA95}\u{200D}¦]+/gu, '').replace(/\u{FE0F}/gu, '');
  }

  updatePreview(evt) {
    const value = evt.target.value;

    if(this.containsEmoji(value)) {
      this.filterEmoji(value);
      return;
    };

    this.charCount.innerText = 300 - parseInt(value.length);

    parseInt(value.length) > 0 ? this.atcBtn.classList.remove("disabled") : this.atcBtn.classList.add("disabled");
    this.atcBtn.setAttribute("data-message", value);
  }

  triggerAddToCart(event) {
    const target = event.currentTarget;
    const isCartDrawer = target.closest("#CartDrawer") ? true : false;
    const id = parseInt(target.getAttribute("data-variant-id"));

    const message = target.getAttribute("data-message");
    const properties = {
      message
    }

    target.querySelector(".loading__spinner").classList.remove("hidden");
    this.cartItems.addToCart(id, 1, properties, isCartDrawer);
  }
}

customElements.define('gift-notes-modal', giftNotesModal);

const giftBoxModal = document.querySelector("[js-gift-box-modal]");

if(giftBoxModal) {
  giftBoxModal.addEventListener('click', evt => {
    if(evt.target.classList.contains("gift-box-modal") || evt.target.classList.contains("close-btn")) {
      giftBoxModal.classList.remove('is-open');
    }
  });
}

function clearCart() {
  const cartJson = JSON.parse(document.querySelector("#cartJson").textContent);
  const isMonogram = cartJson.items.find( item => Object.keys(item.properties).some(key => key.includes("Add up to")));
  const hasMonogram = cartJson.items.find( item => item.variant_id === 39420132556889 || item.variant_id === 39531795382361 || item.variant_id === 39531795415129);
  
  if(!(Object.keys(isMonogram || {}).length === 0 && Object.keys(hasMonogram || {}).length > 0)) return;

  const body = JSON.stringify({
    updates: {
      39420132556889: 0,
      39531795382361: 0,
      39531795415129: 0
    }
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json}' },
    ...{ body }
  })
  .then((response) => {
    return response.json();
  })
  .then(() => {
    window.location.reload();
  })
};

clearCart();

function observeCartChanges() {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
    const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
    const isCartChangeRequest = /\/cart\/(change|update)/.test(entry.name);
    if (isValidRequestType && isCartChangeRequest) {
      setTimeout(function() {
        clearCart();
      }, entry.duration + 1000)
    }
    });
  });
  cartObserver.observe({ entryTypes: ["resource"] });
}

// observeCartChanges();

function initNotifyForm() {
  const notifyForm = document.querySelector("[js-notify-form]");
  if(notifyForm) {
    const spinner = notifyForm.querySelector(".loading__spinner");
    notifyForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      
      spinner.classList.remove("hidden");
      const email = notifyForm.querySelector('[js-notify-email]').value;
      const currentVariant = notifyForm.querySelector('[js-variant-hidden-field]').value;
      const response = await fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        headers: { 
          "accept": "application/json",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8" 
        },
        body: new URLSearchParams({
          "a": "Hqr8HK",
          "email": email,
          "variant": currentVariant,
          "platform": "shopify"
        })
      });

      const result = await response.json();
      
      if (result.success) {
        notifyForm.innerHTML = "<p>Thanks! We'll let you know when this item is back in stock.</p>"
      } else {
        notifyForm.innerHTML = "<p>An unknown error occurred. Please reload the page and try again.</p>"
      }
    });
  }
}
initNotifyForm();
document.addEventListener("notify-form:init", initNotifyForm);

// const mainCollection = document.querySelector("[js-main-collection]");

// if(mainCollection) {
//   const counterEl = mainCollection.querySelector("#collection-counter-wrapper");
//   const colorFilters = mainCollection.querySelector("[js-filter-colors]");
//   const productContainer = mainCollection.querySelector('#ProductGridContainer');
//   const productGridItems = productContainer.querySelectorAll("[js-product-card-list-item]");
//   const colorFacetsItems = colorFilters?.querySelectorAll("[js-color-facets-item]");
//   const activeColorFacets = colorFilters?.querySelectorAll("input:checked");
//   const showMoreColorsBtn = colorFilters?.querySelector("#more-filter-btn");

//   if(activeColorFacets.length) {
//     productGridItems.forEach( productItem => {
//       let isVisible = false;
//       activeColorFacets.forEach( input => {
//         const color = input.getAttribute("data-color");
//         const colorSwatch = productItem.querySelector(`[js-data-variant-image][data-color="${color}"]`);
//         if(colorSwatch) isVisible = true;
//       })

//       if(!isVisible) {
//         productItem.remove();
//       }
//     });

//     productContainer.classList.remove("fade-main-product-grid")
//   }

//   if(counterEl) {
//     let total_products = document.querySelectorAll('#custom-collection-product-Loop [js-product-card-list-item]').length;
  
//     total_products > 1 ?  total_products = `${total_products} items` : total_products = `${total_products} item`;
  
//     document.querySelector('[js-pdp-filter-product-count]').textContent = total_products;
//     counterEl.textContent = total_products;
//   }

//   let url;
//   if(location.pathname.includes("search")) {
//     url = `${location.pathname}${location.search}&section_id=${mainCollection.getAttribute("data-section-id")}`;
//   }else {
//     url = `${location.pathname}?view=ajax-collection&limit=all`;
//   }

//   fetch(url)
//   .then(res => res.text())
//   .then(docs => {
//     const html = new DOMParser().parseFromString(docs, 'text/html');

//     colorFacetsItems.forEach( facets => {
//       const color = facets.getAttribute("data-color");
//       const swatchEl = html.querySelector(`[js-data-variant-image][data-color="${color}"]`);
//       if(swatchEl) return;

//       facets.remove();
//     });

//     const colorVisibleFacets = colorFilters.querySelectorAll("[js-color-facets-item]");
//     [...colorVisibleFacets].slice(0, 5).forEach( item => item.classList.remove("hidden"));

//     if(colorVisibleFacets.length <= 5) showMoreColorsBtn.remove();

//     colorFilters.classList.add("colors__initialize");
//   })
// }

const mainCollection = document.querySelector("[js-main-collection]");

if(mainCollection) {
  if(mainCollection.querySelector("[js-hb-filter-colors]"))
  {
    const colorFilters = mainCollection.querySelector("[js-hb-filter-colors]");
  
    const colorVisibleFacets = colorFilters.querySelectorAll("[js-color-facets-item]");
    [...colorVisibleFacets].slice(0, 5).forEach( item => item.classList.remove("hidden"));
  
    const showMoreColorsBtn = colorFilters?.querySelector("#more-filter-btn");
    if(colorVisibleFacets.length <= 5) showMoreColorsBtn.remove();
  }
}

const facetDrawerTriggerBtn = document.querySelector("[js-facet-drawer-trigger-btn]");
if(facetDrawerTriggerBtn) {
  const closeFacetDrawerBtn = document.querySelector("[js-close-facet-drawer]");
  closeFacetDrawerBtn.addEventListener("click", function() {
    facetDrawerTriggerBtn.dispatchEvent(new Event("click"));
  })
}
    